/**
 * Button color definitions
 *
 * NOTE: This file is a legacy barrel kept for the default Colors export in colors.ts.
 * The canonical source of truth for button colors is ui.colors.ts.
 */
export { buttonColors } from './ui.colors';